import React from 'react';
import { Dimensions, Platform } from 'react-native';
import Drawer, { DrawerElement } from '../Drawer';
import { useAppSelector } from '../../../hooks/store-hook';

// Web/default implementation: keep the existing custom Drawer.
export default function AppDrawer() {
  const drawerState = useAppSelector((s) => s.drawer);
  const lightBoxStore = useAppSelector((s) => s.lightBox);
  const modalStore = useAppSelector((s) => s.modal);
  const isPrimaryLightBoxBlocking = lightBoxStore.visible && !(lightBoxStore.allowBackgroundInteraction ?? false);
  const shouldHideDrawer = drawerState.suspendCount > 0 || modalStore.visible || isPrimaryLightBoxBlocking;

  if (shouldHideDrawer) {
    return null;
  }

  return (
    <Drawer
      drawerElementType={DrawerElement.container}
      dockBottom={Platform.OS !== 'web' || Dimensions.get('window').width <= 768}
      asPopup={Platform.OS === 'web' && Dimensions.get('window').width > 768}
    >
      <Drawer drawerElementType={DrawerElement.header} />
      <Drawer drawerElementType={DrawerElement.content} />
    </Drawer>
  );
}
